/******************************************************************************
 * Created Date: Wed Mar 30th 2022                                            *
 * Author: Jan A.                                                             *
 * -----                                                                      *
 * Last Modified: Thu Jul 07 2022                                             *
 * Modified By: Jan A.                                                        *
 * -----                                                                      *
 * File: /src/common/components/ShiftPopover/components/Popover/index.jsx    *
 * Copyright (c) 2021 Kuva                                                    *
 ******************************************************************************/

import { Popover, Typography } from "@mui/material";
import PropTypes from "prop-types";

import { makeStyles } from "@kuva/ui-components";

/** @function ShiftPopover
* The Popover Alert returns a popover that shows warning message.
* 
  @param {string} id: string that determines which button is hooked on the popover alert
  @param {string} message: string that contains the text content of the component
  @param {handleClose} handleClose:  function to be called when 'Cancel' button is pressed
  @param {string} anchorEl: string that contains HTML element. It's used to set the position of the popover.
  @param {bool} openPopover: boolean that determines whether popover is open or closed
*/

const useStyles = makeStyles()(theme => ({
  typography: {
    backgroundColor: "red",
    padding: theme.spacing(1),
    fontSize: "12px"
  }
}));

const ShiftPopover = ({ id, openPopover, message, handleClose, anchorEl }) => {
  const { classes } = useStyles();
  return (
    <Popover
      id={id}
      open={openPopover}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center"
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "left"
      }}
    >
      <Typography className={classes.typography}>{message}</Typography>
    </Popover>
  );
};

ShiftPopover.defaultProps = {
  message: "You need to finish your session to sign off.",
  openPopover: true
};

ShiftPopover.propTypes = {
  id: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  handleClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.elementType,
  openPopover: PropTypes.bool
};

export default ShiftPopover;
